import { useCallback } from 'react';
import { CounterpartyService } from 'api';
import { BaseParams } from 'api/api.types';
import { AutocompleteInput } from 'components/Inputs';

interface Props {
  name?: string;
  label?: string;
  hiddenLabel?: boolean;
  value: string[];
  onChange: (data: string[]) => void;
  onBlur: () => void;
  error: any;
  counterpartyIds: number;
  withSystemUsers?: boolean;
}

export const MailSelect = ({
  name,
  label,
  hiddenLabel,
  value,
  onChange,
  onBlur,
  error,
  counterpartyIds,
  withSystemUsers = false,
}: Props) => {
  const { loading: isMailsToLoading, getMailAddresses } =
    CounterpartyService.useGetMailAddresses();

  const handleFetch = useCallback(
    (baseParams: BaseParams) =>
      getMailAddresses({
        counterpartyIds,
        withSystemUsers,
        ...baseParams,
      }).then(({ data }) => data.result),
    [getMailAddresses],
  );

  return (
    <AutocompleteInput
      id={name}
      name={name}
      label={label}
      hiddenLabel={hiddenLabel}
      multiple
      freeSolo
      size='small'
      sx={{ width: 300 }}
      onFetch={handleFetch}
      loading={isMailsToLoading}
      error={!!error}
      value={value}
      onChange={(_e, value) => onChange(value)}
      onBlur={onBlur}
    />
  );
};
